import { styled } from "@mui/material";
import ButtonBase from "@mui/material/ButtonBase";

export const CompletedWorkoutButtonBase = styled(ButtonBase)({
  width: "100%",
}) as typeof ButtonBase;
